export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/ticket-change-affirm',
      name: 'distributor-train-front-ticket-change-affirm',
      component: () => import('./index.vue'),
    },
  ]
};
